module.exports = __webpack_public_path__ + "media/styles/images/svg/check-gray-9b5f3f1b94c33f4081edfcd3c4bd1518.svg";